













































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import RangeSlider from "@/components/VRangeSliderStyling.vue";

import * as def from "@/definitions";

import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { ImageLayer } from "@/model/document2/page/surface/design/layer/imageLayer";
import { VectorImageLayer } from "@/model/document2/page/surface/design/layer/vectorImageLayer";

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";

// 図形選択
import SelectPattern from "@/views/designEditor/topController/selectPattern/selectPattern.vue"
// ファイルオープン
import FileOpen from "@/commonComponents/fileOpen/fileOpen.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
    RangeSlider,
    ArrowDown,
    ArrowRight,
    CheckBoxOn,
    SelectPattern,
    FileOpen
  }
})
export default class ImageStyle extends Vue {
    @Prop() private layer!: ImageLayer;

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //こいつはpropsでもらいたい
    openStatus = {
        opend: true
    };

    imageStyleContentsOpenAnimate = false;
    imageStyleContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
        this.imageStyleContentsCloseAnimate = true;
        setTimeout(() => {
            this.imageStyleContentsCloseAnimate = false;
            this.imageStyleContentsOpenAnimate = false;
            this.openStatus.opend = false;
        }, 200);
        } else {
        this.openStatus.opend = true;
        this.imageStyleContentsOpenAnimate = true;
        setTimeout(() => {
            this.imageStyleContentsOpenAnimate = false;
        }, 250);
        }
    }

    private isSelectPatternVisible = false;
    private parentOriginalOverflow = 'scroll';
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    private get opacity() { return this.layer.opacity; }
    private get opacitySliderValue() { return this.opacity; }
    private set opacitySliderValue(value)
    {
        this.changeLayerProperty(value, "opacity", false);
    }
    private onChangeOpacity(value)
    {
        this.changeLayerProperty(value, "opacity", true);
    }

    private get colorFilterR() { return this.layer.colorFilterR; }
    private get colorFilterRSilderValue() { return this.colorFilterR; }
    private set colorFilterRSilderValue(value)
    {
        this.changeLayerProperty(value, "colorFilterR", false);
    }
    private onChangeColorFilterR(value)
    {
        this.changeLayerProperty(value, "colorFilterR", true);
    }

    private get colorFilterG() { return this.layer.colorFilterG; }
    private get colorFilterGSilderValue() { return this.colorFilterG; }
    private set colorFilterGSilderValue(value)
    {
        this.changeLayerProperty(value, "colorFilterG", false);
    }
    private onChangeColorFilterG(value)
    {
        this.changeLayerProperty(value, "colorFilterG", true);
    }

    private get colorFilterB() { return this.layer.colorFilterB; }
    private get colorFilterBSilderValue() { return this.colorFilterB; }
    private set colorFilterBSilderValue(value)
    {
        this.changeLayerProperty(value, "colorFilterB", false);
    }
    private onChangeColorFilterB(value)
    {
        this.changeLayerProperty(value, "colorFilterB", true);
    }

    private get blur() { return this.layer.blur; }
    private get blurSliderValue() { return this.blur; }
    private set blurSliderValue(value)
    {
        this.changeLayerProperty(value, "blur", false);
    }
    private onChangeBlur(value)
    {
        this.changeLayerProperty(value, "blur", true);
    }

    private get ratioFixed()
    {
        return this.layer.keepRatio == 0;
    }

    private ratioFixChange()
    {
        var newValue = this.layer.keepRatio == 0 ? 1 : 0;
        this.changeLayerProperty(newValue, "keepRatio", true, true);
    }

    private get whiteToTransparent()
    {
        return this.layer.whiteTransparent;
    }

    private whiteToTransparentChange()
    {
        this.changeLayerProperty(!this.layer.whiteTransparent, "whiteTransparent", true, true);
    }

    private get flipHorizontal()
    {
        return this.layer.flipHorizontal;
    }

    private flipHorizontalChange()
    {
        this.changeLayerProperty(!this.layer.flipHorizontal, "flipHorizontal", true, true);
    }

    private get flipVertical()
    {
        return this.layer.flipVertical;
    }

    private flipVerticalChange()
    {
        this.changeLayerProperty(!this.layer.flipVertical, "flipVertical", true, true);
    }

    private onTrim()
    {
        // トリミングモードへ
        this.$store.getters.applicationState.lastTrimLayerId = this.layer.id;
        this.changeMode(4);
    }

    private onClip()
    {
        // 図形選択表示
        this.isSelectPatternVisible = true;
        // モーダルが出ている間はサイドバーをスクロールさせない
        const container = document.getElementById('right-controller-control-group');
        if (container) {
            this.parentOriginalOverflow = container.style.overflow || 'scroll';
            container.style.overflow = 'hidden';
        }
    }

    private closeSelectPatternModal()
    {
        this.isSelectPatternVisible = false;
        const container = document.getElementById('right-controller-control-group');
        if (container) {
            container.style.overflow = this.parentOriginalOverflow;
        }
    }

    private onSelectPattern(pattern : number, corner : number)
    {
        // 図形選択された
        // クリップ形状変更
        this.$emit("doCommand", "changeLayerClipShape", { layer : this.layer, pattern : pattern, corner : corner });
        // トリミングモードへ
        this.$store.getters.applicationState.lastTrimLayerId = this.layer.id;
        this.changeMode(4);
        this.closeSelectPatternModal();
    }

    private changeLayerProperty(value: any, propertyName: string, isFinish : boolean = false, isOnce : boolean = false)
    {
        this.$emit("doCommand", "changeLayerProperty", {
            layer: this.layer,
            propertyName: propertyName,
            value: value,
            isFinish : isFinish,
            isOnce : isOnce
        });
    }

    private changeMode(mode)
    {
        this.$emit("doCommand", "changeEditMode", { mode : mode });
    }

    // 画像変更
    private onClickReplaceImage()
    {
        // ダイアログを開いて読み込む
        var fileOpen = this.$refs.fileOpen as FileOpen;
        fileOpen.open();
    }

    // 画像選択時
    private onImageSelected(
        imageBase64: string,
        imageWidth: number,
        imageHeight: number,
        mimeType: string,
        imageBase64WhiteTransparent : string
    )
    {
        // 画像サイズが0の場合には作らない
        if(imageWidth <= 0 || imageHeight <= 0) { return; }

        // 差し替え
        this.$emit("doCommand", "replaceImage", { layer : this.layer, image : imageBase64, imageWhiteTransparent : imageBase64WhiteTransparent, width : imageWidth, height : imageHeight, isSvg : mimeType == "image/svg+xml" || mimeType == "image/svg-xml" });
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigFontColor(){
        var style = {
            color : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
